import IState from "../state"

export const getColumnOrder = (state: IState) => state.templateTable.columnOrder

export const getSorting = (state: IState) => state.templateTable.sorting
export const getDefaultSorting = (state: IState) => state.templateTable.defaultSorting

export const getRowChanges = (state: IState) => state.templateTable.rowChanges

export const getAddedRows = (state: IState) => state.templateTable.addedRows

export const getEditingRowIds = (state: IState) => state.templateTable.editingRowIds

export const getDeletingRowIds = (state: IState) => state.templateTable.deletingRowIds

export const getErrors = (state: IState) => state.templateTable.errors

export const getHiddenColumns = (state: IState) => state.templateTable.hiddenColumns

export const getColumnWidths = (state: IState) => state.templateTable.columnWidths

export const getFilters = (state: IState) => state.templateTable.filters

export const getSelectedRows = (state: IState) => state.templateTable.selectedRows || []
